export interface ApprovalWorkflowState {
  instructionApprovalWorkflow: any[],
  invoiceApprovalWorkflow: any[]
}

export const initialApprovalWorkflowState: ApprovalWorkflowState = {
  instructionApprovalWorkflow: [],
  invoiceApprovalWorkflow: []
};
